import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { mobile, mobileM, tablet } from "../../responsive";
import "./styles.scss";
import SearchBar from "./SearchBar";
import productsData from "../../products";

//
//

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  position: relative;
`;

const Nav = styled.div`
  position: fixed;
  top: 0;
  z-index: 900;
  //
  //
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  padding-bottom: 15px;
  // ** Glass
  background: rgba(248, 248, 248);
  /* -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px); */
  /* border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px; */
  //

  /*  */

  .nav-links {
    list-style: none;
    margin: 0 20px 0 20px;
    color: #272727f8;

    opacity: 0.3;
    text-transform: capitalize;
    text-decoration: none;
    ${mobile({ margin: "0 10px 0 0" })}
  }
  .nav-account {
    list-style: none;

    color: #272727f8;
    opacity: 0.3;
    &:hover {
      color: #272727f8;
      opacity: 0.6;
    }
    ${mobile({ margin: "0 10px 0 0" })}
  }
  //

  .logo-nav {
    padding: 0;
    margin: 20px 0 0 0;
    color: #272727f8;
    text-decoration: none;
    //
    font-weight: 600;
    font-family: Syncopate-Bold;
    text-transform: uppercase;
    font-size: 1.2em;
    //
    /*

                textTransform: "lowercase",
                marginTop: "10px",
                fontFamily: "Syncopate-Bold",


    background: #dd51bf; */
    letter-spacing: 5px;
    transition: all 0.6s ease-in-out;
    ${mobile({ margin: "10px 0 10px 0" })}
  }
`;

const ContainerTabs = styled.div`
  /* background: #fffb00; */
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  ${mobile({
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    margin: "10px 0 10px 0",
  })}
  ${mobileM({
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    margin: "10px 0 10px 0",
  })}
`;
//
// LEFT
//
const Left = styled.div`
  flex: 1;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  text-transform: uppercase;
  ${mobile({
    padding: "0px 0 10px 0",
    margin: "0px 0 10px 0",
  })}
  ${mobileM({
    padding: "0px 0 10px 0",
    margin: "0px 0 10px 0",
  })}
`;

//
const Center = styled.div`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  /* background: #725959; */

  text-align: center;

  //
  //
  //
  text-transform: uppercase;
  ${mobile({ display: "none" })}
  ${mobileM({ display: "none" })}
  ${tablet({ display: "none" })};
`;
//
//
//
//RIGHT
//
//

const Right = styled.div`
  flex: 1;
  gap: 35px;

  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  margin: 0 20px;
  text-transform: uppercase;
  ${mobile({ gap: "15px", justifyContent: "flex-start" })}
`;
//
//
// -------------------------

const NavScroll = () => {
  //

  // const location = useLocation();
  //
  //
  const [navbar, setNavbar] = useState(false);
  const [navigationUp, setNavigationDown] = useState(false);
  const [color, setColor] = useState(false);
  //
  //
  //

  const changeFontOnScroll = () => {
    if (window.scrollY >= 100) {
      setNavbar(true);
      setColor("black");
      setNavigationDown("navigationUp");
    } else {
      setNavbar(false);
      setColor("white");
      setNavigationDown("navigationDown");
    }
  };

  ///

  useEffect(() => {
    window.addEventListener("scroll", changeFontOnScroll, true);
    return () => window.removeEventListener("scroll", changeFontOnScroll);
  }, []);
  //
  //
  //
  //

  return (
    <>
      <Header className={navbar ? "scroll" : "navbar"}>
        <Nav className={navigationUp}>
          {" "}
          <Link to="/" className="logo-nav">
            <h1 className={color}>fluxus</h1>
          </Link>
          <ContainerTabs>
            <Left>
              <SearchBar
                className="input_placeholder"
                placeholder="Search"
                data={productsData}
              />
            </Left>
            <Center>
              <span>
                <Link to="/about" className="nav-links">
                  About
                </Link>
              </span>

              <span>
                <Link to="/allProducts" className="nav-links">
                  Discover
                </Link>
              </span>
              <span className="nav-links">Showroom</span>
              <span className="nav-links">Sale</span>
              <span className="nav-links">Decor</span>
            </Center>
            <Right>
              <Link className="nav-account" as={Link} to="/login">
                <i className="fas fa-user"></i>
              </Link>
              <Link className="nav-account" as={Link} to="/cart">
                <i className="fas fa-shopping-cart"></i>
              </Link>
              <Link className="nav-account" as={Link} to="/likes">
                <i className="far fa-heart"></i>
              </Link>
            </Right>
          </ContainerTabs>
        </Nav>
      </Header>
    </>
  );
};

export default NavScroll;
